import { HumanQuestionRating, JudgingQuestion, PerQuestionComparisonRow, QuestionScoreRow, ScoreBreakdown } from '../../../models';

export const parseScoreBreakdown = (perQuestionScoresJson?: string): ScoreBreakdown | null => {
  if (!perQuestionScoresJson) return null;
  try {
    const parsed = JSON.parse(perQuestionScoresJson) as ScoreBreakdown;
    return { questions: Array.isArray(parsed.questions) ? parsed.questions : [], overall: parsed.overall };
  } catch {
    return null;
  }
};

export const buildPerQuestionComparison = (
  aiQuestions: QuestionScoreRow[],
  humanRatings: HumanQuestionRating[],
  judgingQuestions: JudgingQuestion[],
): PerQuestionComparisonRow[] => {
  const questionMap = new Map(judgingQuestions.map((question) => [question.questionId, question]));
  const humanMap = new Map(humanRatings.map((rating) => [rating.questionId, rating]));

  return [...aiQuestions]
    .sort((a, b) => {
      const ordinalA = questionMap.get(a.questionId)?.ordinal ?? Number.MAX_SAFE_INTEGER;
      const ordinalB = questionMap.get(b.questionId)?.ordinal ?? Number.MAX_SAFE_INTEGER;
      return ordinalA - ordinalB;
    })
    .map((row) => {
      const human = humanMap.get(row.questionId);
      return {
        questionId: row.questionId,
        questionText: questionMap.get(row.questionId)?.question ?? `Question ${row.questionId}`,
        aiScore: row.score,
        aiRationale: row.rationale,
        humanAverage: human?.averageRating ?? null,
        raterCount: human?.raterCount ?? 0,
      };
    });
};
